import {HostUrl, DigmaNetwork, Branches} from './DigmaDef'
/*export const YahaVersion = "build.137" // since build 125, MBO 33!!

//export const HostUrl = "https://tms.digma.me" // Network configuration
// Actual value of HostUrl is set in Login form!! MainDomain
//export var  HostUrl = 'https://tms.digma.me'

export const HostUrl = 'https://digma.tech' // 
export const DigmaNetwork = false
// Only if network...
export const Branches = [HostUrl, 'd1', 'd2', 'd3', 'd4', 'd5', 'd6', 'd7'] // Netword branches - main is always first!
export const BranchNames = ['ראשי', 'דרום', 'מרכז', 'צפון', '**מזרח', '**מערב', '**רחוק', '**קרוב'] // Netword branches - main is always first!
*/

///////// Do not change below this line ==========================================

export const DemoBuild = HostUrl === "https://tms.digma.me"  || HostUrl === 'https://d.digma.me'

export const DevBuild = (HostUrl === "https://tms.digma.me"  || HostUrl === "https://t.digma.me"  || HostUrl === "http://digmame" || HostUrl === "http://yahav")

export const LocalDir = "" // "/yahav"  // used ONLY by  components/Header/Headerlinks

export var yahavToken = ""

class UrlConfig {
    constructor(){
        if (!UrlConfig.instance){
            this.host_url = HostUrl // Was MainDomain
            this.branch = 'cvb'
            UrlConfig.instance = this
        }
        return UrlConfig.instance
    }
    set_mainDomain(value){
        this.host_url = value.includes('https://') ? value : 'https://' + value + '.' + Branches[0].replace('https://','')
        //console.log('UrlConfig Set_mainDomain value=' + value + 'host_url=' + this.host_url)
        return this.host_url
    }
    get_mainDomain(){
        //console.log('UrlConfig Get_mainDomain=', this.host_url)
        return this.host_url
    }
    //instance.get_endPoint(StatsNowEPmboNew)
    get_endPoint(point) {
        console.log('UrlConfig get_endPoint=', this.host_url + point)
        return this.host_url + point
    }
}

export const instance = new UrlConfig()
// Mapping dev vs. production endpoints
// TOGO - find solution for         this.getCombos("6196") // post is ugrrrr..



const WP = "/wp-json/wp/v2"
export const ReferralsEP = () => (DigmaNetwork ? instance.get_mainDomain() : HostUrl) + WP + "/digma_referrals"
//export const ReferralsEPNew = WP + "/digma_referrals"
export const GetReferralsEP = ReferralsEP
export const GetIntakesEP = () => (DigmaNetwork ? instance.get_mainDomain() : HostUrl) + WP + "/digma_intakes" // var uri = "http://yahav/wp-json/wp/v2/digma_intakes"
// export const GetIntakesEP = IntakesEP
export const FamiliesEP = () => (DigmaNetwork ? instance.get_mainDomain() : HostUrl) + WP + "/digma_families" // var uri = "http://yahav/wp-json/wp/v2/digma_families"
export const GetFamiliesEP = FamiliesEP
export const CombosEP = () => (DigmaNetwork ? instance.get_mainDomain() : HostUrl) + WP + "/digma_combos" // var uri = "http://yahav/wp-json/wp/v2/digma_combos"
export const GetCombosEP = HostUrl + WP + "/digma_combos"

export const ParentsEP = () => (DigmaNetwork ? instance.get_mainDomain() : HostUrl) + WP + "/digma_parents" // var uri = "http://yahav/wp-json/wp/v2/digma_parents"
export const GetParentsEP = ParentsEP

const Mbo = "/wp-json/mbo/v3"

export const ReferralMbo = () => (DigmaNetwork ? instance.get_mainDomain() : HostUrl) + Mbo + "/referrals"  // uri_ep = "http://yahav/wp-json/mbo/v3/referrals"
//export const ReferralMboNew =  Mbo + "/referrals"  // uri_ep = "http://yahav/wp-json/mbo/v3/referrals"
export const Ref2IntakeEPmbo = () => (DigmaNetwork ? instance.get_mainDomain() : HostUrl) + Mbo + "/ref2intake" // uri_ep = "http://yahav/wp-json/mbo/v3/ref2intake"
//export const Ref2IntakeEPmboNew = Mbo + "/ref2intake" // uri_ep = "http://yahav/wp-json/mbo/v3/ref2intake"
export const Intake2FamilyEPmbo = () => (DigmaNetwork ? instance.get_mainDomain() : HostUrl) + Mbo + "/intake2family" // uri_ep = "http://yahav/wp-json/mbo/v3/intake2family"
export const GetRnamesEPmbo = (DigmaNetwork ? instance.get_mainDomain() : HostUrl) + Mbo + "/getRnames" // http://yahav/wp-json/mbo/v3/getRnames
export const GetIntakeNamesEPmbo = (DigmaNetwork ? instance.get_mainDomain() : HostUrl) + Mbo + "/getInames" // http://yahav/wp-json/mbo/v3/getRnames
export const GetFamilyNameListEPmbo = HostUrl + Mbo + "/getFnames" // this.newFetch("http://yahav/wp-json/mbo/v3/getFnames")
export const GetFamiliesInProgramNameListEPmbo = () => (DigmaNetwork ? instance.get_mainDomain() : HostUrl) + Mbo + "/families" // this.newFetch("http://yahav/wp-json/mbo/v3/getFnames")
export const CombosEPmbo = HostUrl + Mbo + "/combos" // this.newFetch("http://yahav/wp-json/mbo/v3/getFnames")
export const UpdateFamilyEPmbo = () => (DigmaNetwork ? instance.get_mainDomain() : HostUrl) + Mbo + "/updateFamily" // uri_ep = "http://yahav/wp-json/mbo/v3/updateFamily"
export const LoginEPmbo = HostUrl + Mbo + "/login" // uri_ep = "http://yahav/wp-json/mbo/v3/login"
export const StatsEPmbo = () => (DigmaNetwork ? instance.get_mainDomain() : HostUrl) + Mbo + "/yahavStats" // uri_ep = "http://yahav/wp-json/mbo/v3/yahavStats"
//export const StatsEPmboNew =  Mbo + "/yahavStats" // uri_ep = "http://yahav/wp-json/mbo/v3/yahavStats"
export const StatsNowEPmbo = () => (DigmaNetwork ? instance.get_mainDomain() : HostUrl) + Mbo + "/yahavStatsNow" // uri_ep = "http://yahav/wp-json/mbo/v3/yahavStatsNow"
export const StatsNowEPmboNew = Mbo + "/yahavStatsNow" // uri_ep = "http://yahav/wp-json/mbo/v3/yahavStatsNow"
export const CreateSnapshotEPmbo = () => (DigmaNetwork ? instance.get_mainDomain() : HostUrl) + Mbo + "/createSnapshot" // var uri_ep = "http://yahav/wp-json/mbo/v3/createSnapshot" 
export const ProcessQueryEPmbo = () => (DigmaNetwork ? instance.get_mainDomain() : HostUrl) + Mbo + "/processquery" // var uri_ep = "http://yahav/wp-json/mbo/v3/processquery" 
export const CrudQueryEPmbo = () => (DigmaNetwork ? instance.get_mainDomain() : HostUrl) + Mbo + "/crudquery" // var uri_ep = "http://yahav/wp-json/mbo/v3/crudquery" 
export const GetFormsEPmbo =  () => (DigmaNetwork ? instance.get_mainDomain() : HostUrl) + Mbo + "/leadforms"
export const GetFormsEPmbo2 =  () => (DigmaNetwork ? instance.get_mainDomain() : HostUrl) + Mbo + "/leadforms2"


// User Acounts
export const LoginPage = '/yahav-login/'  // Assuming domain is added via path

/* network config

const  MainDomain = 'https://tms.digma.me'



///////// Only one is active
//export const HostUrl = "https://t.digma.me" // testing PRODUCTION
//export const HostUrl = "https://d.digma.me" // demo site
//export const HostUrl = "https://digma.me" // PRODUCTION


*/

// set by user selection in login form
// used by all server access - fetch etc...


/*
export const HostUrl = instance.get_mainDomain() // 'https://d1.tms.digma.me' // 
*/
